module.exports = __webpack_public_path__ + "prev.8c1f006a.png";